export default{
    cadastra:{
        method:'post',
        url:'trabalhador/backup'
    },
}